import React from 'react';
import { BadgeCent } from 'lucide-react';
import { formatCredits } from '../../constants/credits';

interface CreditPillProps {
  /** The credit cost to display */
  cost: number;
  /** For monitors, show per-lead format instead of total */
  perLead?: boolean;
}

/**
 * Credit cost pill with tooltip - displays inside action buttons
 */
export const CreditPill: React.FC<CreditPillProps> = ({ cost, perLead = false }) => {
  const displayText = perLead ? `${cost}/lead` : formatCredits(cost);
  const tooltipText = perLead
    ? `${cost} credits per lead found`
    : `Estimated cost ~${formatCredits(cost)} credits`;

  return (
    <span className="group/pill relative flex items-center gap-1 px-2 py-0.5 bg-white text-gray-900 text-[11px] font-medium rounded-full border border-gray-200">
      <BadgeCent className="w-3 h-3" />
      {displayText}
      <span className="pointer-events-none absolute bottom-full left-1/2 -translate-x-1/2 mb-2 opacity-0 group-hover/pill:opacity-100 transition-opacity duration-150 z-50">
        <span className="whitespace-nowrap rounded-md bg-gray-900 px-2.5 py-1.5 text-[11px] text-white shadow-lg block">
          {tooltipText}
        </span>
        <span className="absolute left-1/2 -translate-x-1/2 -bottom-1 w-2 h-2 bg-gray-900 rotate-45" />
      </span>
    </span>
  );
};

export default CreditPill;
